import { TourProps, TourStepProps } from 'antd'
import { JSXElementConstructor, Ref } from 'react'

export interface TourStep extends TourStepProps {
  hasTarget: boolean
  elementRef: Ref<any>
  TargetWrapper?: JSXElementConstructor<{
    children: JSX.Element | JSX.Element[]
  }>
}

export type TourConfiguration = {
  steps: { [stepKey: string]: TourStep }
  Tour?: React.FC<TourProps>
}

export const TOURS_CONFIGURATION = {
  fixBot: {
    steps: {
      step1: {
        type: 'primary',
      },
      step2: {
        arrow: true,

        hasTarget: true,
      },
    },
  } as unknown as TourConfiguration,
  remediationChart: {
    steps: {
      step1: {
        arrow: true,
        hasTarget: true,
      },
      step2: {
        arrow: true,
        hasTarget: true,
      },
      step3: {
        arrow: true,
        hasTarget: true,
      },
    },
  } as unknown as TourConfiguration,
  userProfile: {
    steps: {
      step1: {
        type: 'primary',
      },
      step2: {
        hasTarget: true,
        arrow: true,
      },
      step3: {
        hasTarget: true,
        arrow: true,
      },
    },
  } as unknown as TourConfiguration,
  impactReport: {
    steps: {
      step1: {
        type: 'primary',
      },
      step2: {
        hasTarget: true,
        arrow: true,
      },
      step3: {
        hasTarget: true,
        arrow: true,
      },
    },
  } as unknown as TourConfiguration,
  scanIssuesByLocations: {
    steps: {
      step1: {
        type: 'primary',
      },
      step2: {
        hasTarget: true,
        arrow: true,
      },
      step3: {
        hasTarget: true,
        arrow: true,
      },
    },
  } as unknown as TourConfiguration,
}

export type ToursKeys = keyof typeof TOURS_CONFIGURATION
